import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import './Dashboard.css'; // Reuse your professional styles

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    // 1. Automatically extract the token from the URL (?token=xyz)
    const token = searchParams.get("token");

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validate = () => {
        let tempErrors = {};
        if (newPassword !== confirmPassword) tempErrors.confirm = "Passwords do not match.";
        if (!token) tempErrors.token = "Invalid or missing reset token.";
        
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmitting(true);
        try {
            const res = await fetch("/api/v1/auth/password/reset", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // 2. Matches your Java ResetPasswordRequest DTO
                body: JSON.stringify({ token, newPassword })
            });

            if (res.ok) {
                setMessage("Password reset successful! Redirecting to login...");
                setTimeout(() => navigate("/login"), 3000);
            } else {
                setErrors({ global: "Link expired or invalid. Please request a new one." });
            }
        } catch (error) {
            alert("Network error. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="registration-container">
            <form onSubmit={handleSubmit} className="registration-form">
                <h2>Set New Password</h2>
                
                <div className="form-group">
                    <input 
                        type="password" 
                        placeholder="New Password" 
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required 
                    />
                    {errors.password && <span className="error-text">{errors.password}</span>}
                </div>

                <div className="form-group">
                    <input 
                        type="password" 
                        placeholder="Confirm New Password" 
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required 
                    />
                    {errors.confirm && <span className="error-text">{errors.confirm}</span>}
                </div>

                {errors.global && <p className="error-text">{errors.global}</p>}
                {message && <p className="success-text">{message}</p>}

                <button type="submit" disabled={isSubmitting || !token} className="submit-btn">
                    {isSubmitting ? <div className="loader"></div> : "Reset Password"}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
